import nflImg from "../../assets/images/fms-clients/nfl.png"
import premierLeagueImg from "../../assets/images/fms-clients/premier-league.png"
import equinoxImg from "../../assets/images/fms-clients/equinox.png"
import cardinalGlassImg from "../../assets/images/fms-clients/cardinal-glass.png"
import mlbImg from "../../assets/images/fms-clients/major-baseball-league.png"
import usArmyImg from "../../assets/images/fms-clients/us-army.png"
import { useTranslation } from "react-i18next"

interface FmsClientsProps {
}

const FmsClients: React.FC<FmsClientsProps> = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="font-medium text-sm">{t('assessmentResults.trustedBy')}</div>
            <div className="w-full flex flex-wrap items-center justify-between" style={{ gap: "5%" }}>
                <div>
                    <img className="max-h-12" src={nflImg} alt="NFL" />
                </div>
                <div>
                    <img className="max-h-8" src={premierLeagueImg} alt="Premier League" />
                </div>
                <div>
                    <img className="max-h-5" src={equinoxImg} alt="Equinox" />
                </div>
                <div>
                    <img className="max-h-4" src={cardinalGlassImg} alt="Cardinal Glass Industries" />
                </div>
                <div>
                    <img className="max-h-8" src={mlbImg} alt="Major League Baseball" />
                </div>
                <div>
                    <img className="max-h-12" src={usArmyImg} alt="U.S. Army" />
                </div>
            </div>
        </>
    )
};

export default FmsClients;